<template>
  <div id="app">
    <transition name="router-fade" mode="out-in">
      <router-view />
    </transition>
    <div class="mask_wx" v-if="isWx">
      <img src="./images/mask_wx.png" alt="" />
    </div>
  </div>
</template>

<script>
import { QueryString } from "./js/common"
import { PROXY_URL, businessNo } from "./config/env"
import { GetNotifyKey } from "./service/getData"
export default {
  name: "App",
  data () {
    return {
      isWx: false
    }
  },
  mounted () {
    console.log(this)
    console.log("H5改变验证代码")
    let channel = this.getUrl("channel") || ""
    let newChannel
    channel && sessionStorage.setItem('channel', channel)
    if (channel) {
      newChannel = channel &&
        channel == 'fengqun' ?
        'Android_mtf_fengqun' :
        channel == 'xubeiwb1' ?
          'Android_mtf_xubeiwb1' :
          channel == 'xubeiwb2' ?
            'Android_mtf_xubeiwb2' :
            channel == 'xubeiwb3' ?
              'Android_mtf_xubeiwb3' :
              channel == 'xubeiwb4' ?
                'Android_mtf_xubeiwb4' :
                channel == 'xubeiwb5' ?
                  'Android_mtf_xubeiwb5' :
                  "android_xubeimH5"
    } else {
      newChannel = sessionStorage.getItem('newChannel') ?
        sessionStorage.getItem('newChannel') : "android_xubeimH5"
    }
    sessionStorage.setItem('newChannel', newChannel)
    let shq = this.getUrl("shq") || ""
    if (channel.indexOf("zhwk") > -1) {
      console.log("show zhwk")
      localStorage.setItem("zhwk", true)
    }
    if (shq) {
      console.log("shq")
      localStorage.setItem("shq", true)
    }
    this.maskWx()
    this.isMobile()
    // const bd_vid = QueryString("bd_vid") || this.getUrl("bd_vid");
    // const sg_vid = QueryString("bd_vid") || this.getUrl("sg_vid");
    // const qhclickid = QueryString("bd_vid") || this.getUrl("qhclickid");
    const ttclick = QueryString("adid") || this.getUrl("adid") // 头条
    GetNotifyKey({
      businessNo: QueryString("channel") || this.getUrl("channel") || businessNo
    }).then(res => {
      let vid = res.data.result
      let vidValue = QueryString(vid) || this.getUrl(vid)
      if (ttclick) {
        // 头条存储location.href
        if (QueryString(vid)) {
          // query
          let href = decodeURIComponent(
            window.location.href.replace(location.hash, "")
          )
          sessionStorage.setItem("ttclick", href)
        } else if (this.getUrl(vid)) {
          // 如果拼在hash值后面
          let arr = window.location.href.split("?")
          let href = decodeURIComponent(
            window.location.href.replace(location.hash, "")
          )
          sessionStorage.setItem(
            "ttclick",
            `${location.origin}?${arr[arr.length - 1]}`
          )
        }
        return false
      }
      sessionStorage.setItem(vid, vidValue)
    })
    // if (bd_vid) {
    //   sessionStorage.setItem("bd_vid", bd_vid);
    // }
    // if (sg_vid) {
    //   sessionStorage.setItem("sg_vid", sg_vid);
    // }
    // if (qhclickid) {
    //   sessionStorage.setItem("qhclickid", qhclickid);
    // }
    // if (ttclick) {
    //   // 头条存储location.href
    //   if (QueryString("adid")) {
    //     // query
    //     let href = decodeURIComponent(
    //       window.location.href.replace(location.hash, "")
    //     );
    //     sessionStorage.setItem("ttclick", href);
    //   } else if (this.getUrl("adid")) {
    //     // 如果拼在hash值后面
    //     let arr = window.location.href.split("?");
    //     let href = decodeURIComponent(
    //       window.location.href.replace(location.hash, "")
    //     );
    //     sessionStorage.setItem(
    //       "ttclick",
    //       `${location.origin}?${arr[arr.length - 1]}`
    //     );
    //   }
    // }
    channel && localStorage.setItem("channel", channel)

    const initiatorId = this.getUrl("initiatorId") || ""
    const assistModeType = this.getUrl("assistModeType") || ""
    if (initiatorId) {
      sessionStorage.setItem("initiatorId", initiatorId)
      sessionStorage.setItem("assistModeType", assistModeType)
    }

    let that = this
    window["goRightPage"] = function () {
      that.goRightPage()
    }
  },
  methods: {
    getUrl (name) {
      let url = window.location.href
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
      var r = !url.split("?")[1] ? "" : url.split("?")[1].match(reg)
      if (!!r) return decodeURI(r[2])
      return null
    },
    isMobile () {
      let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      let url = window.location.href.indexOf("complaint_advice") > -1
      if (!mobile && url) {
        window.location.href = `http://user.${PROXY_URL.domain}/complaint_advice`
      }
    },
    maskWx () {
      let ua = navigator.userAgent.toLowerCase()
      let isWeixin = ua.indexOf("micromessenger") != -1
      // if (isWeixin) {
      //   this.isWx = true;
      // }

    },
    goRightPage (orderNo) {
      window.location.href = `http://m.${PROXY_URL.domain}/#/rightsProblem?orderNo=${orderNo}`
    },
    goRightPage (orderNo) {
      window.location.href = `http://m.${PROXY_URL.domain}/#/rightsProblem?orderNo=${orderNo}`
    }
  }
};
</script>

<style lang="scss">
@import "./style/reset";

// 引入阿里icon
@font-face {
  font-family: "iconfont"; /* project id 252520 */
  src: url("//at.alicdn.com/t/font_252520_bl2ny27ff54.eot");
  src: url("//at.alicdn.com/t/font_252520_bl2ny27ff54.eot?#iefix")
      format("embedded-opentype"),
    url("//at.alicdn.com/t/font_252520_bl2ny27ff54.woff") format("woff"),
    url("//at.alicdn.com/t/font_252520_bl2ny27ff54.ttf") format("truetype"),
    url("//at.alicdn.com/t/font_252520_bl2ny27ff54.svg#iconfont") format("svg");
}

#app {
  .mask_wx {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.94);
    overflow: hidden;
    img {
      display: block;
      width: px2rem(750rem);
      height: px2rem(270rem);
      margin: 0.12rem auto;
    }
  }
}

.router-fade-enter-active,
.router-fade-leave-active {
  transition: opacity 0.1s;
}
.router-fade-enter,
.router-fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue